// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1618":"8ee0e787124f45d8","2373":"c7b9406ecaa3bd31","2556":"6eae0124d6517378","3767":"c7685dcd54a71c13","8936":"16e8551e3472170e","9509":"cbebe4ddbb8d589a"}[chunkId] + ".css";
};